var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ParagraphBody',[_vm._v(" Great! A new device is ready. ")]),_c('ParagraphBody',[_vm._v(" "+_vm._s(_vm.subheader)+" ")]),(_vm.showInstallerNotes)?_c('InstallerNotes',{class:_vm.$style.notes}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }